import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import "../HomeScreen.css";
import "./Hotels.css";
import Navbar from "../Navbar";
import Footer from "../Footer";

const Hotels = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    checkIn: "",
    checkOut: "",
    guests: "2",
    rooms: "1",
    hotelCategory: "Luxury Hotels",
    requirements: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await addDoc(collection(db, "enquiry"), {
        ...form,
        enquiryType: "hotel booking",
        createdAt: serverTimestamp(),
      });
      setStatus("success");
      setForm({
        name: "", email: "", phone: "", city: "", checkIn: "",
        checkOut: "", guests: "2", rooms: "1", hotelCategory: "Luxury Hotels", requirements: "",
      });
      setTimeout(() => setStatus(null), 4000);
    } catch (err) {
      console.error("Error submitting hotel enquiry: ", err);
      setStatus("error");
    }
  };

  // Hotel Partners Data
  const hotelPartners = [
    { name: "Four Seasons", logo: "🏨" },
    { name: "The Ritz-Carlton", logo: "🌟" },
    { name: "St. Regis", logo: "" },
    { name: "JW Marriott", logo: "🏢" },
    { name: "W Hotels", logo: "✨" },
    { name: "Conrad", logo: "💎" },
    { name: "Shangri-La", logo: "" },
    { name: "Fairmont", logo: "🏰" },
    { name: "Taj Hotels", logo: "🕌" },
    { name: "The Oberoi", logo: "🌺" },
    { name: "ITC Hotels", logo: "" },
    { name: "Hyatt Regency", logo: "🌐" },
    { name: "Lemon Tree", logo: "🍋" },
  ];

  // Hotel Categories
  const hotelCategories = [
    { icon: "👑", name: "Luxury Hotels", desc: "World-class amenities & service" },
    { icon: "🏖️", name: "Beach Resorts", desc: "Sun, sand & serenity" },
    { icon: "👨‍👩‍👧", name: "Family Hotels", desc: "Perfect for family vacations" },
    { icon: "💼", name: "Business Hotels", desc: "Ideal for corporate stays" },
    { icon: "🎨", name: "Boutique Hotels", desc: "Unique & stylish experiences" },
    { icon: "🏡", name: "Villas & Private Residences", desc: "Exclusive private getaways" },
    { icon: "💑", name: "Honeymoon Resorts", desc: "Romantic escapes for couples" },
  ];

  // Why Book With Us
  const whyBookBenefits = [
    { icon: "💰", title: "Best Available Rates", desc: "We match or beat any genuine quote you find online." },
    { icon: "🌟", title: "Exclusive Luxury Deals", desc: "Access to special rates at premium properties worldwide." },
    { icon: "⏰", title: "Early Check-in / Late Check-out", desc: "Flexible timing requests handled on your behalf." },
    { icon: "🍳", title: "Complimentary Breakfast Offers", desc: "Enjoy free breakfast at select partner hotels." },
    { icon: "", title: "Dedicated Travel Consultant", desc: "Personal expert to handle your entire booking." },
    { icon: "📞", title: "24x7 Customer Support", desc: "We are just a call or WhatsApp away, anytime." },
  ];

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section */}
      <section
        className="hero-section hotels-hero"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="hero-overlay">
          <h1>
            Stay in the World's Finest <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> Hotels & Resorts</span>
          </h1>
          <p>Tell us your requirements, and we'll find the best hotels at exclusive negotiated rates.</p>
        </div>
      </section>

      {/* Hotel Partners Section */}
      <section className="hotel-partners-section">
        <div className="section-container">
          <h2 className="section-title-main">Our Preferred Luxury Hotel Partners</h2>
          <p className="section-subtitle">We partner with the world's most prestigious hotel brands to bring you unmatched luxury and comfort.</p>
          <div className="partners-grid">
            {hotelPartners.map((hotel, idx) => (
              <div className="partner-card" key={idx}>
                <div className="partner-logo">{hotel.logo}</div>
                <h4>{hotel.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hotel Categories Section */}
      <section className="hotel-categories-section">
        <div className="section-container">
          <h2 className="section-title-main">Hotel Categories</h2>
          <p className="section-subtitle">Choose from our wide range of curated hotel categories to match your travel style.</p>
          <div className="categories-grid">
            {hotelCategories.map((cat, idx) => (
              <div className="category-card" key={idx}>
                <div className="category-icon">{cat.icon}</div>
                <h3>{cat.name}</h3>
                <p>{cat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Book With Us Section */}
      <section className="why-book-hotels-section">
        <div className="section-container">
          <h2 className="section-title-main">Why Book Hotels With Us?</h2>
          <div className="why-book-grid">
            {whyBookBenefits.map((benefit, idx) => (
              <div className="why-book-item" key={idx}>
                <span className="benefit-icon-large">{benefit.icon}</span>
                <div className="benefit-content">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Enquiry Section */}
      <section className="hotels-enquiry-section">
        <div className="hotels-enquiry-container">

          {/* Left Side: Info */}
          <div className="hotels-info-panel">
            <h2>Ready to Book Your Stay?</h2>
            <ul className="hotels-benefits">
              <li>
                <span className="benefit-icon">💰</span>
                <div>
                  <strong>Best Price Guarantee</strong>
                  <p>We match or beat any genuine quote you find.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🤝</span>
                <div>
                  <strong>Personalized Service</strong>
                  <p>Dedicated travel expert to handle your booking.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🏨</span>
                <div>
                  <strong>Handpicked Hotels</strong>
                  <p>Only verified, quality-assured partner properties.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">📞</span>
                <div>
                  <strong>24/7 Support</strong>
                  <p>We are just a call or WhatsApp away.</p>
                </div>
              </li>
            </ul>

            <div className="hotels-contact-direct">
              <p>Need instant help? Call us directly:</p>
              <a href="tel:+919096785868" className="direct-phone">📞 +91 9096785868</a>
            </div>
          </div>

          {/* Right Side: Enquiry Form */}
          <div className="hotels-form-panel">
            <h3>Hotel Enquiry Form</h3>
            <p className="form-subtitle">Fill in the details below and our team will share the best options within 2 hours.</p>

            <form className="hotels-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label>Full Name *</label>
                  <input type="text" name="name" placeholder="John Doe" value={form.name} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-field">
                <label>Email Address</label>
                <input type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} />
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>City / Destination *</label>
                  <input type="text" name="city" placeholder="e.g., Goa, Mumbai, Dubai" value={form.city} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Hotel Category *</label>
                  <select name="hotelCategory" value={form.hotelCategory} onChange={handleChange} required>
                    <option value="Luxury Hotels">Luxury Hotels</option>
                    <option value="Beach Resorts">Beach Resorts</option>
                    <option value="Family Hotels">Family Hotels</option>
                    <option value="Business Hotels">Business Hotels</option>
                    <option value="Boutique Hotels">Boutique Hotels</option>
                    <option value="Villas & Private Residences">Villas & Private Residences</option>
                    <option value="Honeymoon Resorts">Honeymoon Resorts</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Check-in Date *</label>
                  <input type="date" name="checkIn" value={form.checkIn} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Check-out Date *</label>
                  <input type="date" name="checkOut" value={form.checkOut} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Number of Guests *</label>
                  <select name="guests" value={form.guests} onChange={handleChange} required>
                    <option value="1">1 Adult</option>
                    <option value="2">2 Adults</option>
                    <option value="3">3 Adults</option>
                    <option value="4">4 Adults</option>
                    <option value="5+">5+ (Group)</option>
                  </select>
                </div>
                <div className="form-field">
                  <label>Number of Rooms</label>
                  <select name="rooms" value={form.rooms} onChange={handleChange}>
                    <option value="1">1 Room</option>
                    <option value="2">2 Rooms</option>
                    <option value="3">3 Rooms</option>
                    <option value="4+">4+ Rooms</option>
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label>Special Requirements (Optional)</label>
                <textarea name="requirements" rows="4" placeholder="e.g., Need sea view, near airport, specific hotel name, early check-in, etc." value={form.requirements} onChange={handleChange}></textarea>
              </div>

              {status === "success" && (
                <div className="form-status success">
                  ✅ Enquiry sent successfully! Our team will contact you shortly with the best options.
                </div>
              )}
              {status === "error" && (
                <div className="form-status error">
                  ⚠️ Something went wrong. Please try again or WhatsApp us directly.
                </div>
              )}

              <button type="submit" className="submit-enquiry-btn" disabled={status === "sending"}>
                {status === "sending" ? <span className="btn-spinner"></span> : "Submit Hotel Enquiry"}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Hotels;